<template>
  <v-dialog v-model="detailValue" content-class="view-post-detail-modal" @input="$emit('detailClosed')" max-width="900px" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card v-if="postData !== null">
      <v-toolbar dense class="elevation-2">
        <v-spacer></v-spacer>
        <v-toolbar-title>            
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div class="text-no-wrap font-weight-bold" v-on="on">{{campaignName}} Campaign</div>
          </template>
          <span v-if="currentUserRole !== userRoles.CLIENT">Submitted as <strong>{{submittedCampaignName || campaignName + ' (Unverified)'}}</strong></span>
        </v-tooltip>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDetailModal"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-container fluid class="view-post-detail-modal__body">
        <v-row>
          <v-col md="12" xs="12">
            <div class="mb-2" outlined :key="index" v-for="(postData, index) in postDetails">
                <v-row>
                  <v-col md="8" xs="12">
                    <v-card>
                      <v-card-text>
                        <v-row cols="12">
                          <v-col xs="12" class="text-right">
                            <v-icon small>mdi-history</v-icon> {{formatDate(postData.createdAt)}}
                          </v-col>
                        </v-row>
                        <div v-if="influencerData && !mappedInfluencerData">
                          <v-row cols="12">
                            <v-col xs="6">
                              <!-- <v-avatar size="35" color="grey lighten-4">
                                <img
                                  class="elevation-6"
                                  v-bind:src="paserImageUrl(influencerData.profilePicture)"
                                  alt="avatar"
                                >
                              </v-avatar> -->
                              <a
                                :href="'https://www.tiktok.com/@' + influencerData.username"
                                target="_blank"
                                v-if="influencerData.platform==='tiktok'"
                              ><img src="/static/img/tiktok-32.png" width="20px" /> @{{influencerData.username}}</a>
                              <a
                                :href="'https://youtube.com/' + influencerData.username"
                                target="_blank"
                                v-else-if="influencerData.platform==='youtube'"
                              ><v-icon>mdi-youtube</v-icon> @{{influencerData.username}}</a>
                              <a
                                :href="'https://www.linkedin.com/in/' + influencerData.username"
                                target="_blank"
                                rel="noopener noreferrer"
                                v-else-if="influencerData.platform==='linkedin'"
                              ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{influencerData.username}}</a>
                              <a
                                :href="'https://x.com/' + influencerData.username"
                                target="_blank"
                                rel="noopener noreferrer"
                                v-else-if="postData.type === 'twitter' || influencerData.platform === 'twitter'"
                              ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{influencerData.username}}</a>
                              <a
                                :href="'https://instagram.com/' + influencerData.username"
                                target="_blank"
                                v-else
                              ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{influencerData.username}}</a>
                            </v-col>
                            <v-col xs="6" class="text-right">
                              <v-chip
                                color="primary"
                                v-if="postData.type"
                              >
                                {{ postData.type | platformDisplayName }}
                              </v-chip>
                            </v-col>
                          </v-row>

                        </div>
                        <div v-if="mappedInfluencerData && currentUserRole <= userRoles.AD_STRATEGIST">
                          <v-row cols="12">
                            <v-col xs="6">
                              <!-- <v-avatar size="35" color="grey lighten-4">
                                <img
                                  class="elevation-6"
                                  v-bind:src="mappedInfluencerData.picture"
                                  alt="avatar"
                                >
                              </v-avatar> -->
                              <a
                                :href="'https://tiktok.com/' + mappedInfluencerData.tiktokHandle"
                                target="_blank"
                                v-if="mappedInfluencerData.tiktokHandle"
                              ><img src="/static/img/tiktok-32.png" width="20px" /> @{{mappedInfluencerData.tiktokHandle}}</a>
                              <a
                                :href="'https://youtube.com/' + mappedInfluencerData.youtubeHandle"
                                target="_blank"
                                v-else-if="mappedInfluencerData.youtubeHandle"
                              ><v-icon>mdi-youtube</v-icon> @{{mappedInfluencerData.youtubeHandle}}</a>
                              <a
                                :href="'https://www.linkedin.com/in/' + mappedInfluencerData.linkedinHandle"
                                target="_blank"
                                rel="noopener noreferrer"
                                v-else-if="mappedInfluencerData.linkedinHandle"
                              ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{mappedInfluencerData.linkedinHandle}}</a>
                              <a
                                :href="'https://x.com/' + (mappedInfluencerData.twitterHandle || mappedInfluencerData.instagramHandle)"
                                target="_blank"
                                rel="noopener noreferrer"
                                v-else-if="postData.type === 'twitter' || mappedInfluencerData.twitterHandle"
                              ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{mappedInfluencerData.twitterHandle || mappedInfluencerData.instagramHandle}}</a>
                              <a
                                :href="'https://instagram.com/' + mappedInfluencerData.instagramHandle"
                                target="_blank"
                                v-else
                              ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{mappedInfluencerData.instagramHandle}}</a>
                            </v-col>
                            <v-col xs="6" class="text-right">
                              <v-chip
                                color="primary"
                                v-if="postData.type"
                              >
                                {{ postData.type | platformDisplayName }}
                              </v-chip>
                            </v-col>
                          </v-row>
                          <v-row cols="12">
                            <v-col v-if="influencerData" class="text-center">
                              <p>
                              Submitted By:
                              <!-- <v-avatar size="35" color="grey lighten-4">
                                <img
                                  class="elevation-6"
                                  v-bind:src="paserImageUrl(influencerData.profilePicture)"
                                  alt="avatar"
                                >
                              </v-avatar> -->
                              <a
                                :href="'https://www.tiktok.com/@' + influencerData.username"
                                target="_blank"
                                v-if="influencerData.platform==='tiktok'"
                              ><img src="/static/img/tiktok-32.png" width="20px" /> @{{influencerData.username}}</a>
                              <a
                                :href="'https://youtube.com/' + influencerData.username"
                                target="_blank"
                                v-else-if="influencerData.platform==='youtube'"
                              ><v-icon>mdi-youtube</v-icon> @{{influencerData.username}}</a>
                              <a
                                :href="'https://www.linkedin.com/in/' + influencerData.username"
                                target="_blank"
                                rel="noopener noreferrer"
                                v-else-if="influencerData.platform==='linkedin'"
                              ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{influencerData.username}}</a>
                              <a
                                :href="'https://x.com/' + influencerData.username"
                                target="_blank"
                                rel="noopener noreferrer"
                                v-else-if="postData.type === 'twitter' || influencerData.platform === 'twitter'"
                              ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{influencerData.username}}</a>
                              <a
                                :href="'https://instagram.com/' + influencerData.username"
                                target="_blank"
                                v-else
                              ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{influencerData.username}}</a>
                              </p>
                            </v-col>
                          </v-row>
                        </div>

                        <v-container grid-list-sm container--fluid>
                          <v-alert
                            :value="postData.images.length === 0"
                            color="info" icon="info"
                            outlined
                          >
                            No Media found for this post.
                          </v-alert>
                          <v-layout row wrap justify-center justify-space-around v-if="postData.images !== undefined">
                            <v-flex v-for="img in postData.images" :key="img.url" md4 xs12>
                              <v-card text tile v-if="img.publicID && img.isvideo">
                                <custom-media-v2
                                  :media="campaignHelper.customPostMediaConfig(img, { videoDownload: true })"
                                />
                              </v-card>
                              <v-card text tile v-else>                      
                                <v-hover v-if="!img.isvideo">
                                  <div
                                    class="post-cld-img cursor-pointer"
                                    @click="viewMedia(img)"
                                    v-if="img.publicID">
                                    <custom-media-v2
                                      :media="campaignHelper.customPostMediaConfig(img, { trans: { width: 320, crop: 'scale' } })"
                                    />
                                  </div>
                                  <v-img
                                    :src="img.thumbnail || img.url"
                                    :lazy-src="img.url"
                                    aspect-ratio="1"
                                    class="grey lighten-2 mx-auto"
                                    slot-scope="{ hover }"
                                    :class="`elevation-${hover ? 12 : 2}`"
                                    @click="viewMedia(img.url, img.video)"
                                    v-else
                                  />
                                </v-hover>
                                <div v-if="img.isvideo" class="elevation-8">
                                  <video id="previewVideo" width="100%" controls>
                                    <source :src="img.url" type="video/mp4">
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              </v-card>
                              <btn-download :url="img.url" v-if="img.type === 'video/quicktime'"></btn-download>
                            </v-flex>
                          </v-layout>
                        </v-container>                
                        <div class="body-1" v-if="postData.captionText">
                          <v-textarea
                            class="post-caption-textarea"
                            readonly 
                            filled
                            auto-grow        
                            rows="4"           
                            label="Caption"        
                            v-model="postData.captionText"     
                            counter       
                            >
                          </v-textarea>                                   
                        </div>
                        <div v-if="postData.type === 'story' || postData.type === 'video'  || postData.type === 'reel' || postData.type === 'tiktok' || postData.type === 'youtube' || postData.type === 'facebook'">
                          <!-- <v-text-field  
                            readonly       
                            filled                       
                            type="text"
                            label="Link"                                                
                            :value="postData.vdoLink"
                            >
                          </v-text-field> -->
                          <div v-if="postData.vdoLink" class="caption-label"> 
                            Link
                          </div>
                          <div v-if="postData.vdoLink" class="caption-text">
                            {{postData.vdoLink}}
                          </div>
                        </div>

                        <div class="body-1" v-if="postData.type === 'story' && currentUserRole !== 5">
                          <v-textarea
                            readonly 
                            filled
                            auto-grow        
                            rows="4"           
                            label="Remark"        
                            v-model="postData.remark"     
                            counter       
                            >
                          </v-textarea>                                   
                        </div>

                        <v-layout row wrap justify-center style="margin-top:20px;">
                          <div xs12 md6 v-if="postData.postDate">
                            <v-chip label class="subheading ma-1">
                              <span>Scheduled:&nbsp;</span>
                              <strong>{{postData.postDate}}</strong>
                              <strong>{{postData.postDateEnd ? `&nbsp; to ${postData.postDateEnd}` : ''}}</strong>
                            </v-chip>
                          </div>
                          <div xs12 md6>
                            <v-chip label class="subheading ma-1">
                              <span>Status:&nbsp;</span>
                              <strong>{{loadPostStatusDisplay(postData)}}</strong>
                            </v-chip>
                          </div>
                          <div xs12 md12 v-if="postData.postURL">
                            <v-chip label class="subtitle-1 ma-1">
                              <v-avatar><v-icon>link</v-icon></v-avatar>
                              <strong><a :href="postData.postURL" target="_blink">View Live Post</a></strong>
                            </v-chip>
                          </div>
                        </v-layout>
                        <v-divider></v-divider>
                        <!-- Post Rate Review By Client -->
                        <v-flex v-if="postReviewApproved" centered>
                          <v-card v-if="postData.clientAcceptReview">
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex md6 xs12 class="text-center">
                                  <p class="subtitle-1">Rating on influencer's quality of work</p>
                                  <v-rating
                                    class="ma-5"
                                    v-model="postData.clientAcceptReview.rate"
                                    color="secondary"
                                    size="30"
                                    readonly dense
                                  ></v-rating>
                                  <p class="font-weight-bold">{{postData.clientAcceptReview.rate}}/5 stars Rated</p>
                                </v-flex>
                                <v-flex md6 xs12 class="text-center">
                                  <div class="subtitle-1" max-width="100">
                                    <p>Comment for Influencer</p>
                                    <v-textarea text filled readonly v-model="postData.clientAcceptReview.comment"></v-textarea>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col md="4" xs="12" v-if="postAbuseHistory && postData.clientReportAbuse.length > 0">
                    <v-expansion-panels class="detail-report-abuse-section">
                      <v-expansion-panel v-for="(item, i) in postData.clientReportAbuse" :key="i">
                        <v-expansion-panel-header>
                          <div class="subtitle-1" color="red lighten-4">
                            <v-icon color="deep-orange">report_problem</v-icon>
                            Reported Abuse
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="report-abuse-expansion">
                          <v-card>
                            <v-card-text class="grey lighten-3 pl-1 pr-1">
                              <h4>Reasons for Non-Approval</h4>
                              <p>
                                <ol>
                                  <li v-for="r in item.reasons" :key="r">{{r}}</li>
                                </ol>
                              </p>
                              <h4>Comments for Abuse:</h4>
                              <!-- <v-textarea
                                style="max-height:30vh;overflow-y:auto"
                                readonly
                                filled
                                auto-grow
                                rows="4"
                                v-model="item.comment"
                                counter
                                >
                              </v-textarea> -->
                              <!-- <textarea style="max-height: 300px;min-height: 200px;overflow-y: auto;" rows="4" readonly>{{item.comment}}</textarea> -->
                              <div style="max-height: 300px;min-height: 200px;overflow-y: auto;" v-html="renderHTML(item.comment)">
                              </div>
                              <div class="text-xs-right caption font-weight-italic">{{formatDate(item.date)}}</div>
                              <div v-if="item.files">
                                <h4>Uploaded Screenshots:</h4>
                                <p>
                                  <ol>
                                    <li v-for="(f, index) in item.files" :key="index">
                                      <a :href="f.url" target="_blank" v-if="f.url">{{utilsFunc.getFileNameFromURL(f.url)}}</a>
                                    </li>
                                  </ol>
                                </p>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
            </div>
            <v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="closeDetailModal" text>Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <!-- <v-col md="5" xs="12" v-if="postAbuseHistory && clientReportAbuse.length > 0">
          </v-col> -->
          <!-- <v-col md="5" xs="12" v-if="(overRideBySuperAdmin || postAbuseHistory) && clientReportAbuse.length > 0">
            <v-expansion-panels>
              <v-expansion-panel v-for="(item, i) in clientReportAbuse" :key="i">
                <v-expansion-panel-header>
                  <div class="subtitle-1" color="red lighten-4">
                    <v-icon color="deep-orange">report_problem</v-icon>
                    Reported Abuse
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text class="grey lighten-3">
                      <h4>Reasons for Non-Approval</h4>
                      <p>
                        <ol>
                          <li v-for="r in item.reasons" :key="r">{{r}}</li>
                        </ol>
                      </p>
                      <h4>Comments for Abuse:</h4>
                      <p>
                        {{item.comment}}
                      </p>
                      <div class="text-xs-right caption font-weight-italic">{{formatDate(item.date)}}</div>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col> -->
        </v-row>
        <post-media-viewer-modal
          :viewerValue="mediaViewerDialog"
          :media="mediaItem"
          :videoPlayer="videoPlayer"
          @closed="closeMediaViewerModal"
        />
      </v-container>
    </v-card>
  </v-dialog>
</template>
<style scoped>
  .caption-label {
    font-size: 14px;
    color: #3F3FFF;
    font-weight: 400;
  }

  .caption-text {
    font-size: 12px;
    font-weight: 600;
    margin-bottom:20px;
    padding:10px;
    background-color: rgb(0, 0, 0, 0.06)
  }

  .detail-report-abuse-section {
    padding: 2px;
    max-height: 500px;
    overflow-y: auto;
  }
</style>
<style>
  .v-application .v-dialog.view-post-detail-modal > .v-card > .view-post-detail-modal__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
<script>
import config from '@/config';
import postConfig from './postConfig';
import campaignHelper from '../Campaign/campaignHelper';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
import PostMediaViewerModal from './PostMediaViewerModal.vue';
import utils from '@/utils'
import moment from 'moment';
export default {
  name: 'ViewPostDetailModal',
  components: {
    CustomMediaV2,
    PostMediaViewerModal
  },
  props: {
    campaignName: String,
    submittedCampaignName: String,
    postDetails: Object,
    postReviewApproved: Boolean,
    mappedInfluencerData: Object,
    influencerData: Object,
    userObj: Object,
    clientReportAbuse: Array,
    postAbuseHistory: Boolean,
    detailValue: Boolean
  },
  data() {
    return {
      utilsFunc: utils.func,
      mediaViewerDialog: false,
      mediaItem: '',
      videoPlayer: false,
      campaignHelper
    };
  },
  watch: {
    detailValue(newVal) {
      /* eslint-env jquery */
      // let modalHeight = $('.view-post-detail-modal').height()
      // let reposeAbuseHeight = modalHeight - 135
      // $('.report-abuse-section').css({'max-height': `${reposeAbuseHeight}px;overflow:auto;`});
    }
  },
  methods: {
    paserImageUrl(url) {
      if (!url) return null
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi')
      return newUrl
    },
    viewMedia(media, isVideo) {
      if (isVideo) {
        this.videoPlayer = true
      } else {
        this.videoPlayer = false
      }
      this.mediaItem = media
      this.mediaViewerDialog = true
    },
    loadPostStatusDisplay(newPost) {
      let currentUserRole = this.userObj.role
      if (currentUserRole === config.userRoles.CLIENT) {
        return postConfig.postStatusDisplayForClient[newPost.status]
      } else if (currentUserRole === config.userRoles.INFLUENCER) {
        return postConfig.postStatusDisplayForInfluencer[newPost.status]
      } else if (currentUserRole === config.userRoles.AD_STRATEGIST || currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
        return postConfig.postStatusDisplayForCS[newPost.status]
      } else {
        return config.postStatusDisplayInternal[newPost.status].display
      }
    },
    closeDetailModal() {
      this.detailValue = false
      this.$emit('detailClosed')
    },
    closeMediaViewerModal() {
      this.mediaViewerDialog = false
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY, HH:mm');
    },
    renderHTML(text) {
      if (text !== undefined && text !== null) {
        return text.replace(/\n/g, `<p><p>`);
      }
      return ''
    }
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    postStatusConfig: function() {
      return config.postStatus;
    },
    userRoles: function() {
      return config.userRoles;
    }
  }
};
</script>



// WEBPACK FOOTER //
// ViewPostDetailModal.vue?5e582e8f